import { render, staticRenderFns } from "./incluirloteamostras.vue?vue&type=template&id=d6a07bfc&"
import script from "./incluirloteamostras.vue?vue&type=script&lang=js&"
export * from "./incluirloteamostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports